var map = {
	"./attachment.svg": "9fe5",
	"./cloud.svg": "4347",
	"./cloud_circle.svg": "7c3c",
	"./cloud_done.svg": "5500",
	"./cloud_download.svg": "3600",
	"./cloud_off.svg": "e96e",
	"./cloud_queue.svg": "10d1",
	"./cloud_upload.svg": "8653",
	"./create_new_folder.svg": "540b",
	"./file_download.svg": "5ff5",
	"./file_upload.svg": "816f",
	"./folder.svg": "0a2a",
	"./folder_open.svg": "1e7c",
	"./folder_shared.svg": "f9d3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "60e9";